import React from 'react';
import { Grid, Card, CardContent, Skeleton, Typography, Box } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import DashboardCard from '../../common/DashboardCard';

/**
 * items: [{ key, title, icon, format?: (v) => string, trend?: 'up'|'down', trendValue?: string }]
 * data: { [key]: number|string } | null
 * loading: boolean
 * error: string | null
 */
const KpiGrid = ({ items, data, loading, error }) => {
  const mdSize = Math.max(12 / items.length, 3);
  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={12} sm={6} md={mdSize} key={item.key}>
          {loading ? (
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" height={40} />
                <Skeleton variant="text" width="80%" />
              </CardContent>
            </Card>
          ) : error ? (
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography color="textSecondary" variant="body2" gutterBottom>
                  {item.title}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', color: 'error.main', mt: 1 }}>
                  <ErrorOutline fontSize="small" sx={{ mr: 1 }} />
                  <Typography variant="body2">Failed to load</Typography>
                </Box>
              </CardContent>
            </Card>
          ) : (
            <DashboardCard
              title={item.title}
              tooltip={item.tooltip}
              value={
                data == null || data[item.key] == null
                  ? '—'
                  : item.format
                  ? item.format(data[item.key])
                  : data[item.key]
              }
              subtitle={item.subtitle ? item.subtitle(data) : undefined}
              icon={item.icon}
              trend={item.trend ? item.trend(data) : undefined}
              trendValue={item.trendValue ? item.trendValue(data) : undefined}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default KpiGrid;
